<template>
 <div>
    <b-row>
      <b-col sm="2">
        <div class="text-window">
          <b-row>
            <b-col sm="12">
             <b-input v-model="freeFilter" @change="$emit('changeFreeWordFilter', $event)" size="sm" placeholder="フリーワード検索"/>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="9">
        <div class="text-window">
          <b-row>
            <b-col sm="1">
              <b-input v-model="asinFilter" @change="$emit('changeAsinFilter', $event)" size="sm" placeholder="ASIN"/>
              <!-- <b-input v-model="asinFilter" @change="$emit('changeAsinFilter', $event)" size="sm" placeholder="ASIN" :disabled="modeNotConfirm"/> -->
            </b-col>
            <b-col sm="2">
              <b-input-group size="sm" prepend="フォーム">
                <b-select size="sm" v-model="formFilter" @change="$emit('changeFormFilter', $event)" :options="invoiceFormTypes"/>
              </b-input-group>
            </b-col>
            <b-col sm="2">
              <!-- <b-input-group size="sm" prepend="材料">
                <b-select size="sm" v-model="materialFilter" @change="$emit('changeMaterialFilter', $event)" :options="invoiceMaterialTypes"/>
              </b-input-group> -->
              <material-search @selectedMaterial="$emit('selectedMaterial', $event)"/>
            </b-col>
            <b-col sm="2">
              <category-search @selectedCategory="$emit('selectedCategory', $event)"/>
            </b-col>
            <b-col sm="2">
              <maker-search @selectedMaker="$emit('selectedMaker', $event)"/>
            </b-col>
            <b-col sm="2">
              <b-input-group size="sm" prepend="状態">
                <b-select size="sm" v-model="statusFilter" @change="$emit('changeStatusFilter', $event)" :options="invoiceDatabaseStatusTypes"/>
              </b-input-group>
            </b-col>
            <b-col sm="1">
              <b-button size="sm" @click="$emit('filterSearch')" variant="danger">検索</b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="1">
        <b-button size="sm" @click="$emit('outputFile')" variant="danger">　ファイル出力　</b-button>
        <label class="for-fbanumber" size="sm" @click="$emit('outputFileAll')">全件出力</label>
      </b-col>
    </b-row>
    <b-row class="component-margin-top-half">
      <b-col sm="2">
        <h6>表示件数: {{ recordCount }} 件</h6>
      </b-col>
    </b-row>
 </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import InvoiceFormType from '@/types/InvoiceFormType';
// import InvoiceMaterialType from '@/types/InvoiceMaterialType';
import InvoiceDatabaseStatusType from '@/types/InvoiceDatabaseStatusType';
import SearchCategory from '@/components/invoice/SearchCategory';
import SearchMaker from '@/components/invoice/SearchMaker';
import SearchMaterial from '@/components/invoice/SearchMaterial';

export default {
  mixins: [BaseComponent],
  props: {
    freeFilter: { default: ''},
    asinFilter: { default: ''},
    formFilter: { default: '0' },
    // materialFilter: { default: '0' },
    statusFilter: { default: '1' },
    recordCount: { default: '0' }
  },
  data() {
    return {
      invoiceFormTypes: InvoiceFormType.values(),
      // invoiceMaterialTypes: InvoiceMaterialType.values(),
      invoiceDatabaseStatusTypes: InvoiceDatabaseStatusType.values(),
      categoryItem: {},
      // categoryName: '-',
    };
  },
  methods: {
    selectedCategory(item) {
      this.categoryItem = {};
      if (item !== null) {
        // Object.assign(this.editItem , row.item);
        this.categoryItem =  Object.assign({}, this.categoryItem , item);
        this.categoryName = item.categoryName;
      }
    },
  },
};

Vue.component('category-search', SearchCategory);
Vue.component('maker-search', SearchMaker);
Vue.component('material-search', SearchMaterial);

</script>
<style>
.component-margin-top-half {
  margin-top: 0.5rem;
}
.for-fbanumber{
  text-decoration: underline;
  cursor: pointer;
}
</style>
